// extracted by mini-css-extract-plugin
export default {"container":"Body_container__OxUVn","sectionWrapper":"Body_sectionWrapper__Z9fhM"};